import fixable    from './fixable.mixin';
import sortable   from './sortable.mixin';
import comparable from './comparable.mixin';


export default [
    fixable,
    sortable,
    comparable
]


// WEBPACK FOOTER //
// ./src/components/common/table_v3/mixin/external.mixin.js